import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private configPromise: Promise<AppConfig>;

  constructor() { }

  public getAppConfig(): Promise<AppConfig> {
    if (! this.configPromise) {
      this.configPromise = new Promise((resolve, reject) => resolve({
        societyUrl: 'https://jogavdennomzivote.sk',
        societyLogoFile: 'logo-cz.png',
        locale: 'cs',
        currencySign: 'Kč',
        currencyCode: 'CZK'
      }));
    }
    return this.configPromise;
  }
}

export class AppConfig {
  societyUrl: string;
  societyLogoFile: string;
  locale: string;
  currencySign: string;
  currencyCode: string;
}
